import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { GetDate } from '../../app/AppUtils';
import DefaultExcelExport from '../subcomponents/DefaultExcelExport';

export default function ExportExcelAttendance({ disabled, jsonData }) {
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);

    const [excelDataRows, setExcelDataRows] = useState([]);
    const [excelHeaderRow, setExcelHeaderRow] = useState([]);
    const [excelTitleRows, setExcelTitleRows] = useState([]);
    const [excelFileName, setExcelFileName] = useState("");

    useEffect(() => {
        if (jsonData) {
            let data = jsonData?.attendanceListStudents.map(({ studentId, ...rest }) => rest);

            // Title rows
            setExcelTitleRows([[`${jsonData?.activityName} - ${jsonData?.performanceNumber}`]]);

            if (data.length > 0) {
                // Header row
                let headerRow = [
                    `${resourceFinal[appLanguage].words.STUDENT}${resourceFinal[appLanguage].words.NAME.toLowerCase()}`,
                    `${resourceFinal[appLanguage].words.STUDENT}${resourceFinal[appLanguage].words.NUMBER.toLowerCase()}`,
                    resourceFinal[appLanguage].words.CLASS
                ];

                const momentDates = [...data[0]?.attendanceMoments.map(m => GetDate(m.momentStart))];
                headerRow.push(...momentDates);

                setExcelHeaderRow(headerRow);

                // Data rows
                let dataRows = [];

                data?.forEach(item => {
                    let row = [
                        item.studentFullName,
                        item.studentNumber,
                        item.studentSchoolclass
                    ];

                    item.attendanceMoments.forEach(a => {
                        row.push(a.attendance !== null ? (a.attendance ? resourceFinal[appLanguage].words.PRESENT : resourceFinal[appLanguage].words.PRESENT_NOT) : "");
                    });

                    dataRows.push(row);
                });

                setExcelDataRows(dataRows);
            }

            // File name
            setExcelFileName(`${resourceFinal[appLanguage].words.ATTENDANCE} - ${jsonData?.activityName} (${jsonData?.performanceNumber})`);
        }
    }, [jsonData]);

    return (
        <DefaultExcelExport
            titleRows={excelTitleRows}
            headerRow={excelHeaderRow}
            dataRows={excelDataRows}
            fileName={excelFileName}
            iconButton
            buttonText={`${resourceFinal[appLanguage].words.ATTENDANCE} ${resourceFinal[appLanguage].words.EXPORT}`}
            disabledCondition={disabled}
        />
    );
}
